import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  BjHomeResponse,
  MobileMainInfo,
  WebMainInfoResponse,
  WebMainLayoutDefaultParam,
  WebMainPageResponse,
  WebMainParam,
} from './type';

export const fetchWebMainPage = async (params?: WebMainParam) => {
  const res = await fetchExtended(`/v1/page/www`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as WebMainPageResponse;
};

export const fetchWebMainInfo = async (params?: WebMainLayoutDefaultParam) => {
  const res = await fetchExtended(`/v1/page/www/layout/default`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as WebMainInfoResponse;
};

export const fetchBjHome = async () => {
  const res = await fetchExtended(`/v1/main/bj_home`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as BjHomeResponse;
};

export const fetchMobileMainInfo = async (params?: WebMainParam) => {
  const res = await fetchExtended(`/v1/page/m`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as MobileMainInfo;
};
